import { ApiRoute } from 'api-base-refrence';
import { InformationApiRoute } from './information.api';

export class ChartComulativeProvinceApiRoute extends ApiRoute {
  static apiName = '';
  static parent = InformationApiRoute;
  static urlPattern() {
    return `/chart-comulative-province`;
  }
}
